<template>
  <v-form ref="form" lazy-validation>
  <v-dialog v-model="dialog" max-width="1200px" persistent>
    <v-card>
      <v-card-title>
        {{ $t('label.documentacao') }} - {{ $t('label.tipos_fornecedor.representante_legal') }} - {{ $t('label.grupo_fornecedor') }} {{ grupo ? grupo.nome : '' }}
      </v-card-title>

      <v-card-text style="max-height: 70vh; overflow-y: auto;">
        <v-row>
          <v-col cols="12" md="5">
            <dropzone-form
              :key="'dz-' + isProcuracao"
              ref="dropzoneForm"
              class="dropzone-achatado"
              :id="uploadFileDropzoneId"
              :maxFileSizeInMB="50"
              :url="uriUpload"
              :upload-multiple="!isProcuracao"
              :auto-process-queue="false"
              :show-button-send="false"
              @UPLOADFILE_FILE_ADDED="preencherDescricaoComNomeArquivo"
              @UPLOADFILE_SENDING="enviandoArquivo"
              @UPLOADFILE_SENDING_MULTIPLE="enviandoMultiplosArquivos"
              @UPLOADFILE_SUCCESS="uploadSucesso"
              @UPLOADFILE_SUCCESS_MULTIPLE="uploadSucessoMultiplo"
            />

            <v-row class="mt-0 ml-1">
              <v-col cols="12">
                <v-checkbox
                  v-model="isProcuracao"
                  :label="$t('label.procuracao')"
                  off-icon="radio_button_unchecked"
                  on-icon="radio_button_checked"
                  :disabled="!usuario.indProcurador"
                  hide-details
                />
              </v-col>

              <v-col cols="6" v-if="isProcuracao">
                <v-text-field
                  :value="dataInicioFormatada"
                  :rules="[rules.required]"
                  disabled
                  :label="$t('label.inicio_vigencia')"
                />
              </v-col>

              <v-col cols="6" v-if="isProcuracao">
                <v-text-field
                  :value="dataFimFormatada"
                  :rules="[rules.required]"
                  disabled
                  :label="$t('label.fim_vigencia')"
                />
              </v-col>
            </v-row>

            <div class="d-flex justify-end mt-4">
              <v-btn color="primary" @click="submitDropzone">{{ $t('label.enviar') }}</v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="7" class="pl-md-4">
            <list-files
              v-if="dialog && grupo && grupo.id"
              ref="listFiles"
              :uri="uri"
              :col-xs="'12'"
              :col-sm="'12'"
              :col-md="'6'"
              :col-lg="'4'"
              :habilitar-exclusao="true"
              :habilitar-texto-file="true"
              @ListFiles__arquivos="(files) => $emit('FormAnexoArquivo__qtde', files.length)"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="fechar">{{ $t('label.fechar') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-form>
</template>

<script>
import DropzoneForm from '@/shared-components/upload/DropzoneForm';
import ListFiles from '@/shared-components/files/ListFiles';
import basePath from '@/common/functions/api-resource';
import { formatDateDDMMYYYYBarras } from '@/common/functions/date-utils';

export default {
  name: 'UsuarioFornecedorDocumentacaoDialog',
  components: {
    DropzoneForm,
    ListFiles,
  },
  props: {
    usuario: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      grupo: null,
      isProcuracao: false,
      descricaoArquivo: '',
      dataInicio: '',
      dataFim: '',
      menuInicio: false,
      menuFim: false,
      uploadFileDropzoneId: `myVueDropzone${(Math.random() * 1000000).toString().replace('.', '')}`,
      rules: {
        required: (value) => {
          if (!this.isProcuracao) {
            return true;
          }
          const msg = this.$t('message.campo_obrigatorio');
          return !!(value) || msg;
        },
      },
    };
  },
  computed: {
    uri() {
      const urlBase = basePath('job', 'arquivo/usuario');
      return `${urlBase}/${this.usuario.id}/grupo-fornecedor/${this.grupo ? this.grupo.id : ''}`;
    },
    uriUpload() {
      const urlBase = basePath('job', 'arquivo/usuario');
      const sufixo = this.isProcuracao ? 'upload' : 'upload-multiplo';
      return `${urlBase}/${this.usuario.id}/grupo-fornecedor/${this.grupo ? this.grupo.id : ''}/${sufixo}`;
    },
    dataInicioFormatada() {
      return this.dataInicio ? formatDateDDMMYYYYBarras(this.dataInicio) : null;
    },
    dataFimFormatada() {
      return this.dataFim ? formatDateDDMMYYYYBarras(this.dataFim) : null;
    },
  },
  methods: {
    alternarRadio() {
      this.isProcuracao = !this.isProcuracao;
    },
    open(grupoSelecionado, dtaInicio, dtaFim) {
      this.grupo = grupoSelecionado;
      this.dialog = true;
      this.isProcuracao = false;
      this.dataInicio = dtaInicio;
      this.dataFim = dtaFim;
    },
    fechar() {
      this.dialog = false;
    },
    submitDropzone() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.$refs.dropzoneForm && typeof this.$refs.dropzoneForm.submitForm === 'function') {
        this.$refs.dropzoneForm.submitForm();
      }
    },

    enviandoArquivo(file, xhr, formData) {
      formData.append('descricao', encodeURI(this.descricaoArquivo));
      formData.append('idGrupoFornecedor', this.grupo.id);
      if (this.dataInicio) formData.append('dtaInicioVigencia', this.dataInicio);
      if (this.dataFim) formData.append('dtaFimVigencia', this.dataFim);
    },

    enviandoMultiplosArquivos(files, xhr, formData) {
      files.forEach((file) => {
        const indexUltimoPonto = file.name.lastIndexOf('.');
        const nomeArquivo = file.name.substring(0, indexUltimoPonto);
        const extensaoArquivo = file.name.substring(indexUltimoPonto);

        const novaDescricao = `${nomeArquivo}-${this.usuario.id}${extensaoArquivo}`;
        formData.append(`descricoes[${file.name}]`, encodeURI(novaDescricao));
      });
    },

    preencherDescricaoComNomeArquivo(file) {
      if (this.uploadMultiple) {
        return;
      }

      this.descricaoArquivo = file.name;
    },

    uploadSucesso(response) {
      this.finalizarUploadComSucesso(response, 1);
    },

    uploadSucessoMultiplo(response) {
      this.finalizarUploadComSucesso(response);
    },

    finalizarUploadComSucesso(response, fallback = 1) {
      let quantidade = fallback;
      if (response?.detail && Array.isArray(response.detail)) {
        quantidade = response.detail.length;
      } else if (Array.isArray(response)) {
        quantidade = response.length;
      }

      this.$toast(this.$tc('label.upload_arquivo_sucesso', quantidade));
      this.$emit('documentacao-upload-success', quantidade);

      this.isProcuracao = false;
      this.dataInicio = '';
      this.dataFim = '';

      const dz = this.$refs.dropzoneForm;
      if (dz && typeof dz.resetForm === 'function') dz.resetForm();
      else if (dz && typeof dz.reset === 'function') dz.reset();

      if (this.$refs.listFiles && typeof this.$refs.listFiles.refresh === 'function') {
        this.$refs.listFiles.refresh();
      }
    },
  },
};
</script>
<style scoped>
.dropzone-achatado {
  min-height: 120px !important;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
</style>
